export default "The game is now over. \n\nYour final Unit Cost for the game ended at:\n\n<center><strong>%gameScore% NB/Unit</strong></center>";